import type { SVGProps } from 'react';
const SvgIconMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M0 2.5a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 2.5M0 8a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8m.75 4.75a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5z"
    />
  </svg>
);
export default SvgIconMenu;
